module.exports = __webpack_public_path__ + "static/media/pp-1.30fa29b5.jpg";